import styled from "styled-components";
import { useSelector } from "react-redux";
import { useModal } from "../../hooks/useModal";
import { FOOTER_FOREGROUND, FUNNEL_DESIGNS } from "../../templates/strings";

const FooterAnchor = styled.a`
  cursor: pointer;
  text-decoration: ${({ $shouldUnderline }) =>
    $shouldUnderline ? "underline" : "none"};
  font-weight: ${({ $fontWeight }) => ($fontWeight ? $fontWeight : "normal")};
  font-size: ${({ $fnlDesign, color, $fontSize }) =>
    $fontSize
      ? `${$fontSize}px`
      : $fnlDesign === FUNNEL_DESIGNS.MODERN && !color
        ? "16px"
        : "12px"};
  color: ${({ $fnlDesign, $footerForeground, color }) =>
    color
      ? color
      : $fnlDesign === FUNNEL_DESIGNS.MODERN
        ? "#adadad"
        : $footerForeground === FOOTER_FOREGROUND.SHADOWED
          ? "#fff"
          : $footerForeground};
  &:hover {
    color: ${({ $fnlDesign, $footerForeground, color }) =>
      color
        ? color
        : $fnlDesign === FUNNEL_DESIGNS.MODERN
          ? "#adadad"
          : $footerForeground === FOOTER_FOREGROUND.SHADOWED
            ? "#fff"
            : $footerForeground};
  }
`;

const AnchorElement = ({
  href,
  modalData,
  anchorText,
  footerForeground,
  classes = "",
  color = null,
  fs = null,
  fw = null,
  shouldUnderline = false
}) => {
  const { funnel } = useSelector((state) => state.funnelInfo);
  const { handleModalData } = useModal();
  const handleModal = (data) => {
    handleModalData({ ...data, show: true });
  };
  return (
    <FooterAnchor
      $fontSize={fs}
      $fontWeight={fw}
      href={href}
      color={color}
      target="_blank"
      rel="noreferrer"
      className={classes}
      $fnlDesign={funnel.funnelDesign}
      $shouldUnderline={shouldUnderline}
      onClick={() => handleModal(modalData)}
      $footerForeground={footerForeground}
    >
      {anchorText}
    </FooterAnchor>
  );
};
export default AnchorElement;
